export default __webpack_public_path__ + "static/media/sass-logo.a2591e27.png";